export default __webpack_public_path__ + "static/media/ava-08.1fe9fc16.png";